<template>
  <div>
    <div class="search flex">
      <span class="tit">微信模板管理</span>
    </div>

    <div class="instrument">
      <el-table :data="data" class="record-table"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400'}"
                height="calc(100vh - 320px)"
                max-height="calc(100vh - 320px)">
        <el-table-column prop="templateName" label="模板名字" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="templateCode" label="模板代码" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateTime" label="最后更新时间" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" width="100">
          <template slot-scope="props">
            <el-button @click="edit(props.row)" size="mini" type="text" class="btn">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-drawer :wrapperClosable="false"
               :show-close="false" :title="detail.templateName"
               :visible.sync="dialogFormVisible"  class="drawerCommon"
               :before-close="handleClose">
      <el-form>
        <div v-for="o in detail.templateValue.templateData" :key="o.id">
          <el-form-item :label="o.value">
            <div v-if="o.value==='简述'"></div>
            <el-color-picker v-else value="#567CFF"></el-color-picker>
          </el-form-item>
        </div>
        <el-form-item label="警告">
          颜色不得使用白色
        </el-form-item>
        <el-form-item>
          <el-button @click="submit" type="primary" round>提交</el-button>
          <el-button @click="dialogFormVisible=false" round>取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import common from "../../../api/common";

export default {
  name: "weChatTemplateList.vue",
  data() {
    return {
      data: [],
      title: '',
      detail: {
        templateValue: {
          redirectUrll: '',
          templateData: {
            first: ''
          }
        }

      },
      dialogFormVisible: false,
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      this.$ajax
          .get(common.api.message.template.weChat.list)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.data = res.data.list;
              let val;
              $(that.data).each((i, o) => {
                val = JSON.parse(o.templateValue);
                o.templateValue = val;
              })
              console.log(that.data)
            }
          })
    },
    edit(item) {
      this.detail = item;
      this.dialogFormVisible = true;
    },
    handleClose() {
      this.dialogFormVisible = false;
    },
    submit() {
      this.detail.templateValue = JSON.stringify(this.detail.templateValue);
      let that = this;
      this.$ajax
          .post(common.api.message.template.weChat.update, this.detail)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.$message.success('成功');
              that.handleClose();
              that.getData();
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败');
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';


.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}


.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>